import React from 'react';
import { Store } from 'react-notifications-component';
import { getNotificationParamsFromResponse } from '../../../helpers/getNotificationParamsFromResponse/getNotificationParamsFromResponse';
import { resolveCreateNotification } from '../../../helpers/resolveCreateNotification/resolveCreateNotification';
import { NotificationContent } from '../../../ui/NotificationContent/NotificationContent';
import { LegacyActionType } from '../../types/LegacyActionType';
import { NotificationType } from '../../types/NotificationType';

interface NotifyOptions {
  title?: string;
  message: string;
  type?: NotificationType;
  duration?: number;
}

class NotificationService {
  private defaultDuration = 5000;

  private show({
    title,
    message,
    type = 'info',
    duration = this.defaultDuration,
  }: NotifyOptions) {
    Store.addNotification({
      insert: 'bottom',
      container: 'bottom-right',
      type,
      dismiss: { duration },
      animationIn: ['animate__animated', 'animate__fadeIn'],
      animationOut: ['animate__animated', 'animate__fadeOut'],
      content: () => (
        <NotificationContent type={type} title={title} message={message} />
      ),
    });
  }

  /* ===== Modern API ===== */

  success({ title = 'Успех', message }: { title?: string; message: string }) {
    this.show({ type: 'success', title, message });
  }

  error({ title = 'Ошибка', message }: { title?: string; message: string }) {
    this.show({ type: 'danger', title, message });
  }

  info({ title = 'Информация', message }: { title?: string; message: string }) {
    this.show({ type: 'info', title, message });
  }

  warning({
    title = 'Предупреждение',
    message,
  }: {
    title?: string;
    message: string;
  }) {
    this.show({ type: 'warning', title, message });
  }

  /* ===== Backward compatibility ===== */

  async processResponseNotification(
    response: any,
    actionType?: LegacyActionType
  ) {
    if (actionType) {
      const { status, title, text } = getNotificationParamsFromResponse(
        response,
        actionType
      );
      this.show({
        type: status,
        title,
        message: text,
      });
    } else {
      try {
        const { title, message, type } = await resolveCreateNotification(
          response
        );
        this.show({
          title,
          message,
          type,
        });
      } catch (error) {
        console.error('Ошибка при создании уведомления:', error);
        this.show({
          title: 'Ошибка',
          message: 'Не удалось обработать ответ сервера',
          type: 'danger',
        });
      }
    }
  }
}

export default new NotificationService();
